/* Second Unit Crew */
import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import styles from "../../styles/Callsheets.module.css";

const Info = () => {
  return (
    <div>
        <Row className='mb-3'>
            <Col className={`px-3 py-2 ${styles.SubTitle6 }`} md={{span: 8, offset: 2 }}>
            <h5 className={`text-center pb-2 ${styles.Red }`} >2ND UNIT CREW INFO</h5> 
            <hr className={`mt-2 mb-0`}/>
            <p className='mt-2'><span className={`${styles.Red}`}>*</span> <span className={`${styles.Red}`}>Add</span> Second Unit Crew members in the Add New position form.
           </p>
           <p className='mt-2'><span className={`${styles.Red}`}>*</span> <span className={`${styles.Red}`}>Register</span> Crew members in the Manage Users section on the Home page
            similarly to Main Crew if they are needed to access the App.
           </p>
           <p className='mt-2'><span className={`${styles.Red}`}>*</span> <span className={`${styles.Red}`}>Important!</span> If a Main Crew member, who has already been Registered, is also being used for the 
            Second Unit they should not be Registered as second time but they should be added to the Second
            Unit Crew Info as well as the Main Crew Info.
           </p>
           <hr className={`mt-2 mb-0`}/>
            </Col>
        </Row>
    </div>
  )
}

export default Info